import { Novedad } from "@services/NovedadesService";

export interface NovedadColorDefinition {
    backgroundColor: string;
    foregroundColor: string;
}

export const defaultNovedadColorsByAcronym: Record<string, NovedadColorDefinition> = {
    P: {
        backgroundColor: "#F5F4F7",
        foregroundColor: "#5F6F8E",
    },
    "P-T": {
        backgroundColor: "#F5F4F7",
        foregroundColor: "#CD5600",
    },
    "P-ST": {
        backgroundColor: "#F5F4F7",
        foregroundColor: "#D90023",
    },
    FR: {
        backgroundColor: "#DBEAFE",
        foregroundColor: "#1D4ED8",
    },
    AU: {
        backgroundColor: "#D90023",
        foregroundColor: "#FFD3D4",
    },
    FE: {
        backgroundColor: "#F3E8FF",
        foregroundColor: "#7E22CE",
    },
    VAC: {
        backgroundColor: "#FEF3C7",
        foregroundColor: "#B45309",
    },
    V: {
        backgroundColor: "#FEF3C7",
        foregroundColor: "#B45309",
    },
    EN: {
        backgroundColor: "#FF505A",
        foregroundColor: "#2D0002",
    },
    DES: {
        backgroundColor: "#300E00",
        foregroundColor: "#FFEAE6",
    },
    C: {
        backgroundColor: "#FFD3D4",
        foregroundColor: "#5B0008",
    },
};

export const getDefaultNovedadColors = (acronym?: string): NovedadColorDefinition | undefined => {
    if (!acronym) {
        return undefined;
    }

    return defaultNovedadColorsByAcronym[acronym];
};

export const getNovedadColors = (novedad: Pick<Novedad, "acronym" | "backgroundColor" | "foregroundColor">): NovedadColorDefinition | undefined => {
    const defaultColors = getDefaultNovedadColors(novedad.acronym);
    const backgroundColor = novedad.backgroundColor || defaultColors?.backgroundColor;
    const foregroundColor = novedad.foregroundColor || defaultColors?.foregroundColor;

    if (!backgroundColor && !foregroundColor) {
        return undefined;
    }

    return {
        backgroundColor: backgroundColor ?? "",
        foregroundColor: foregroundColor ?? "",
    };
};
